"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var useStyles_1 = __importDefault(require("../useStyles"));
var useDialogTitleClasses = function (classes, showCloseButton) {
    var _a = classes.title, titleClasses = _a === void 0 ? {} : _a;
    var innerClasses = (0, useStyles_1.default)();
    var dialogTitleClasses = (0, react_1.useMemo)(function () {
        var _a;
        return (__assign(__assign({}, titleClasses), { root: (0, classnames_1.default)((_a = {},
                _a[titleClasses.root] = !!titleClasses.root,
                _a[innerClasses.titleWithCloseIcon] = showCloseButton,
                _a[innerClasses.root] = true,
                _a)) }));
    }, [
        innerClasses,
        titleClasses,
        showCloseButton
    ]);
    return dialogTitleClasses;
};
exports.default = useDialogTitleClasses;
